import type { OrganLookupCode } from '@repo/types';

export const organAnchorId = (lookupCode: OrganLookupCode) =>
  `organ-${lookupCode}`;
